import {ORIENTATIONS} from './../constants/globalConstants';

const getOrientationFromDimensions = (width, height) => {
  if (width > height) {
    return ORIENTATIONS.LANDSCAPE;
  } else if (height > width) {
    return ORIENTATIONS.PORTRAIT;
  } else {
    return ORIENTATIONS.SQUARE;
  }
};

export default getOrientationFromDimensions;
